import { useEffect, useState } from "react";

export const RateRect = ({ rate, elOne, elTwo, borderColor }) => {
  const [midpoint, setMidpoint] = useState({ x: 0, y: 0 });
  useEffect(() => {
    const wrapper = document.querySelector(".timetable-grid");
    const element1 = document.querySelector(`.${elOne}`);
    const element2 = document.querySelector(`.${elTwo}`);

    if (wrapper && element1 && element2) {
      const wrapperRect = wrapper.getBoundingClientRect();
      const rect1 = element1.getBoundingClientRect();
      const rect2 = element2.getBoundingClientRect();

      const x1 = rect1.left + rect1.width / 2 - wrapperRect.left;
      const y1 = rect1.top + rect1.height / 2 - wrapperRect.top;
      const x2 = rect2.left + rect2.width / 2 - wrapperRect.left;
      const y2 = rect2.top + rect2.height / 2 - wrapperRect.top;

      setMidpoint({
        x: (x1 + x2) / 2,
        y: (y1 + y2) / 2
      });
    }
  }, []);

  const hideBlock = midpoint.x === 0 && midpoint.y === 0;

  return (
    <div
      className="rate-rect"
      style={{
        position: "absolute",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        top: `${midpoint.y - 10}px`,
        left: `${midpoint.x - 25}px`,
        width: "48px",
        height: "24px",
        backgroundColor: "#000",
        fontSize: "14px",
        fontWeight: "bold",
        border: `2px solid ${borderColor}`,
        zIndex: 100,
        visibility: hideBlock ? "hidden" : "visible"
      }}
    >
      {rate}%
    </div>
  );
};
